import React, { useEffect, useState } from "react";
import { DownIcon, UpDownIcon, UpIcon } from "../Assets/iconshere";
import Skeleton from "react-loading-skeleton";
import { humanReadable } from "../utils/useWindowDimensions";
import moment from "moment";
import ReactPaginate from "react-paginate";
import axios from "axios";
import { useSelector } from "react-redux";

const UserEngagementTable = ({ type, list, loading, setPage, page, limit, pageCount, sortBy, setSortBy }) => {
  const startIndex = Math.min(page * limit + 1, pageCount);
  const endIndex = Math.min((page + 1) * limit, list.length);
  const displayStart = startIndex;
  const displayEnd = startIndex + endIndex - 1;
  const [sortOrder, setSortOrder] = useState("asc");

  const handlePageClick = ({ selected }) => {
    setPage(selected);
  };

  const handleSort = (key) => {
    if (sortBy === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(key);
      setSortOrder("asc");
    }
  };

  const sortedList = list.slice().sort((a, b) => {
    if (type === "visits" || type === "session") {
      if (sortBy === "platform") {
        return sortOrder === "asc" ? a.platform.localeCompare(b.platform) : b.platform.localeCompare(a.platform);
      } else if (sortBy === "timestamp") {
        const dateA = new Date(a.startTime);
        const dateB = new Date(b.startTime);
        return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
      } else if (sortBy === "spentTime") {
        return sortOrder === "desc" ? a.time - b.time : b.time - a.time;
      }
    } else if (type === "eventsList" || type === "eventDuration") {
      if (sortBy === "eventName") {
        return sortOrder === "asc" ? a.platform.localeCompare(b.eventName) : b.platform.localeCompare(a.eventName);
      } else if (sortBy === "environmentName") {
        return sortOrder === "asc"
          ? a.platform.localeCompare(b.environmentName)
          : b.platform.localeCompare(a.environmentName);
      } else if (sortBy === "actualEventTime") {
        return sortOrder === "asc" ? a.actualEventTime - b.actualEventTime : b.actualEventTime - a.actualEventTime;
      } else if (sortBy === "activityDuration") {
        return sortOrder === "asc" ? a.activityDuration - b.activityDuration : b.activityDuration - a.activityDuration;
      }
    }
    // Return 0 if no sorting is needed
    return 0;
  });

  return (
    <>
      {(type === "visits" || type === "session") && (
        <>
          <div className="stickyhead reports">
            <table className="table withsort align-middle table-nowrap mb-0">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>
                    <span className="d-flex align-items-center justify-content-center gap-2 sort">Platform Name</span>
                  </th>
                  <th>
                    <span
                      className="d-flex align-items-center justify-content-center gap-2 sort"
                      onClick={() => handleSort("timestamp")}
                    >
                      Timestamp
                      {sortBy === "timestamp" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                  <th>
                    <span
                      className="d-flex align-items-center justify-content-center gap-2 sort"
                      onClick={() => handleSort("spentTime")}
                    >
                      Time Spent
                      {sortBy === "spentTime" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {!loading ? (
                  <>
                    {sortedList.map((e, i) => {
                      return (
                        <tr key={i + 1}>
                          <td>{i + 1 + page * limit}</td>
                          <td>{e.platform}</td>
                          <td>{moment(e.startTime).format("LLL")}</td>
                          <td>{humanReadable(e.time)}</td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {[...Array(10)].map((_, index) => (
                      <tr key={index}>
                        <td>
                          <Skeleton width="3vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className="row w-100 pb-3 ms-1">
            {pageCount > 0 && (
              <div className="col-lg-6 ps-0 d-flex align-items-center justify-content-start">
                <span className="page-num">
                  Showing{" "}
                  <span className="ps-1 pe-1">
                    {displayStart} - {displayEnd}
                  </span>{" "}
                  of <span className="ps-1">{pageCount}</span>
                </span>
              </div>
            )}
            <div className="col-lg-6 d-flex align-items-center justify-content-end">
              <ReactPaginate
                pageCount={Math.ceil(pageCount / limit)}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                onPageChange={handlePageClick}
                previousLabel="<"
                nextLabel=">"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item-pre"
                previousLinkClassName="page-link"
                nextClassName="page-item-next"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
              />
            </div>
          </div>
        </>
      )}
      {(type === "eventsList" || type === "eventDuration") && (
        <>
          <div className="stickyhead reports">
            <table className="table withsort align-middle table-nowrap mb-0">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th className="text-start">
                    <span
                      onClick={() => handleSort("name")}
                      className="d-flex align-items-center justify-content-start gap-2 sort"
                    >
                      Event Name
                      {sortBy === "eventName" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                  <th className="text-start">
                    <span
                      className="d-flex align-items-center justify-content-center gap-2 sort"
                      onClick={() => handleSort("environmentName")}
                    >
                      Event Environment
                      {sortBy === "environmentName" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                  <th>
                    <span
                      className="d-flex align-items-center justify-content-center gap-2 sort"
                      onClick={() => handleSort("actualEventTime")}
                    >
                      Event duration
                      {sortBy === "actualEventTime" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                  <th>
                    <span
                      className="d-flex align-items-center justify-content-center gap-2 sort"
                      onClick={() => handleSort("activityDuration")}
                    >
                      Time Spent
                      {sortBy === "activityDuration" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {!loading ? (
                  <>
                    {sortedList.map((e, i) => {
                      return (
                        <tr key={i + 1}>
                          <td>{i + 1}</td>
                          <td className="nameimage">{e.eventName}</td>
                          <td>{e.environmentName}</td>
                          <td>{humanReadable(e.actualEventTime)}</td>
                          <td>{humanReadable(e.activityDuration)}</td>
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {[...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td>
                          <Skeleton width="3vw" />
                        </td>
                        <td className="nameimage">
                          <Skeleton count={1} circle height="35px" width="35px" className="me-3" />
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className="row w-100 pb-3 ms-1">
            {pageCount > 0 && (
              <div className="col-lg-6 ps-0 d-flex align-items-center justify-content-start">
                <span className="page-num">
                  Showing{" "}
                  <span className="ps-1 pe-1">
                    {displayStart} - {displayEnd}
                  </span>{" "}
                  of <span className="ps-1">{pageCount}</span>
                </span>
              </div>
            )}
            <div className="col-lg-6 d-flex align-items-center justify-content-end">
              <ReactPaginate
                pageCount={Math.ceil(list.length / limit)}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                onPageChange={handlePageClick}
                previousLabel="<"
                nextLabel=">"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item-pre"
                previousLinkClassName="page-link"
                nextClassName="page-item-next"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default UserEngagementTable;
